const theme = {
  'primaryColor': '#8FD5BD',
  'globalHeader': {
    'headerIcon': 'arrowGrey',
  }
}

export { theme }